import React, { useState, useEffect } from "react";
import { ShowToastUtil } from "../utilities/showToastUtil";
import ApiRequest from "../services/apiService";
import baseUrl from "../services/baseUrl";
import { useNavigate } from "react-router-dom";
import { Alert } from "react-bootstrap";
import GetUserData from "../utilities/getUserDetails";
import LoginCheck from "./userAuthentication";

const InactivityLogout = () => {
  const [lastActivityTime, setLastActivityTime] = useState(Date.now());
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const INACTIVITY_TIMEOUT = 1800000;
  const [userInfo, setUserInfo] = useState(GetUserData());

  const handleUserActivity = () => {
    setLastActivityTime(Date.now());
  };

  const navigate = useNavigate();
  const logoutUser = async () => {
    try {
      const url = `${baseUrl()}/Account/Logout`;

      const response = await ApiRequest({
        apiLink: url,
        method: "GET",
      });
      if (response.message === "Logged out successfully") {
        try {
          const params = new URLSearchParams({
            userCode: userInfo.UserCode,
            logoutTime: new Date().toISOString(),
          });
          const url = `${baseUrl()}/nps/RemoveUserTrail?${params.toString()}`;
          const response = await ApiRequest({
            apiLink: url,
            method: "GET",
          });
          if (response.Message === "Success") {
          } else {
            ShowToastUtil(response.Description || "Failed to delete user trail", "error");
          }
        } catch (error) {
          ShowToastUtil("Something went wrong with user trail deletion", "error");
        }
        sessionStorage.clear();
        localStorage.clear();
        window.location.reload();
      } else {
        console.error("Logout failed");
      }
    } catch (error) {
      console.error("Error:", error);
    }
    try {
      const params = new URLSearchParams({
        userCode: userInfo.UserCode,
        logoutTime: new Date().toISOString(),
      });
      const url = `${baseUrl()}/nps/RemoveUserTrail?${params.toString()}`;
      const response = await ApiRequest({
        apiLink: url,
        method: "GET",
      });
      if (response.Message === "Success") {
      } else {
        ShowToastUtil(response.Description || "Failed to delete user trail", "error");
      }
    } catch (error) {
      ShowToastUtil("Something went wrong with user trail deletion", "error");
    }
    navigate("/login");
    sessionStorage.clear();
    localStorage.clear();
    window.location.reload();
    console.log("You have been logged out due to inactivity.");
  };

  useEffect(() => {
    const handleIdleTimeout = () => {
      if (Date.now() - lastActivityTime > INACTIVITY_TIMEOUT) {
        logoutUser();
      }
    };

    const inactivityCheckInterval = setInterval(handleIdleTimeout, 60000);

    const events = ["mousemove", "keydown", "scroll", "click"];
    events.forEach((event) =>
      window.addEventListener(event, handleUserActivity)
    );

    return () => {
      clearInterval(inactivityCheckInterval);
      events.forEach((event) =>
        window.removeEventListener(event, handleUserActivity)
      );
    };
  }, [lastActivityTime]);

  const userId = localStorage.getItem("loginEmail");
  const userPass = localStorage.getItem("loginPassKey");

  useEffect(() => {
    const loginCheckInterval = setInterval(async () => {
      const response = await LoginCheck(userId, userPass, "fetchKey");
      if (response && localStorage.getItem('isAuth')) {
        if (localStorage.getItem("validationKey") !== response.ValidationKey) {
          ShowToastUtil("Another user has logged in", "error");
          ShowToastUtil("Terminating session in 3seconds ", "info");
          setTimeout(() => {
            logoutUser();
          }, 3000);
        }
      }
    }, 10000); 
    return () => {
      clearInterval(loginCheckInterval);
    };
  }, [userId, userPass]);
};

export default InactivityLogout;
